import React, { useEffect } from "react";

/**
 * ThankYouPage (React)
 * - Com Tailwind CSS (classes já escritas)
 * - Dispara evento para GA4 (gtag) e para dataLayer (GTM)
 * - Pequeno CTA, botão voltar para home e link para contato
 *
 * Instruções:
 * 1) Coloque este componente na rota /obrigado (ex: pages/obrigado.jsx no Next.js)
 * 2) Garanta que seu formulário redirecione para /obrigado após o envio
 * 3) Tenha o snippet do Google Analytics (gtag) ou Google Tag Manager carregado no site
 *
 * Evento enviado:
 * - dataLayer push: { event: 'form_submit', formType: 'contato' }
 * - gtag event: 'form_submit'
 */

export default function ThankYouPage() {
  useEffect(() => {
    // push para dataLayer (GTM)
    try {
      if (
        typeof window !== "undefined" &&
        Array.isArray((window as any).dataLayer)
      ) {
        (window as any).dataLayer.push({
          event: "form_submit",
          formType: "contato",
          page_path: window.location.pathname,
        });
      }
    } catch (e) {
      // fail silently
    }

    // gtag (GA4) event
    try {
      const gtag = (window as any).gtag;
      if (typeof gtag === "function") {
        gtag("event", "form_submit", {
          event_category: "engagement",
          event_label: "thank_you_page",
          value: 1,
        });
      }
    } catch (e) {
      // fail silently
    }
  }, []);

  return (
    <main className="min-h-screen flex items-center justify-center bg-slate-50 p-6">
      <section className="max-w-3xl w-full bg-white rounded-2xl shadow-md p-8 md:p-12">
        <header className="flex items-start gap-4">
          <div className="flex-none w-16 h-16 bg-green-100 rounded-full grid place-items-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-8 h-8 text-green-600"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M9 12l2 2 4-4"
              />
            </svg>
          </div>
          <div>
            <h1 className="text-2xl md:text-3xl font-semibold text-slate-800">
              Obrigado! Recebemos sua mensagem.
            </h1>
            <p className="mt-2 text-slate-600">
              Nossa equipe vai analisar e entrar em contato em até 1-2 dias
              úteis.
            </p>
          </div>
        </header>

        <div className="mt-6 grid gap-4 md:grid-cols-3">
          <a
            href="/"
            className="md:col-span-1 inline-flex items-center justify-center rounded-xl py-3 px-4 bg-slate-800 text-white hover:opacity-95 transition"
          >
            Voltar para o site
          </a>
        </div>

        <div className="mt-8 text-sm text-slate-600">
          <p>
            Se você tiver algo urgente, ligue para{" "}
            <a
              className="text-slate-800 font-medium underline"
              href="tel:+551199999999"
            >
              +55 (33) 4042-2018
            </a>{" "}
            ou envie um e-mail para{" "}
            <a
              className="text-slate-800 font-medium underline"
              href="mailto:comercial@invictustecnologia.com"
            >
              comercial@invictustecnologia.com
            </a>
            .
          </p>
        </div>

        <footer className="mt-8 border-t pt-4 text-xs text-slate-500">
          <p>
            Esta página também serve como sinalizador de conversão para Google
            Analytics / Google Tag Manager.
          </p>
        </footer>
      </section>
    </main>
  );
}
